import cn from "classnames";
import { useLocation } from "react-router";

import logo from "../../assets/logo.svg";
import { LanguageSelector } from "../../components/language-detector/language-detector";
import { MobileMain } from "../../components/mobile/mobile-main";
import styles from "./mobile.module.scss";

export function Mobile() {
  const { pathname } = useLocation();
  const path = pathname.split("/")[1];
  const isEmbed = path === "embed";
  const hideHeader = isEmbed;

  return (
    <div className={cn(styles.mobileWrapper, !isEmbed && styles.mobileWrapperScrollable)}>
      {!hideHeader && (
        <div className={styles.mobileHeader}>
          <img src={logo} alt="logo" />
          <LanguageSelector />
        </div>
      )}
      <div className={cn(styles.mobileContent, !isEmbed && styles.mobileContentScrollable)}>
        <MobileMain isEmbed={isEmbed} />
      </div>
    </div>
  );
}
